<template>
  <div class="w-full flex bg-white border-round">
    <div class="flex items-center w-full">
      <div class="w-4/12 p-16">
        <h1 class="text-3xl mb-0 text-dark font-semibold">Brand Profile</h1>
        <p class="fsize14 text-gray mb-0">
          Setup your brands logos and trademarks.
        </p>
        <div class="shadow-lg border-round mt-8 px-8 pt-6 pb-32 relative">
          <div>
            <small class="text-sm text-primary font-semibold">Step 2</small>
            <h1 class="fsize21 col-4f mb-0 font-semibold">Business Niche</h1>
            <p class="fsize14 col-4f mb-0">Enter your business category</p>
          </div>

          <div class="mt-6">
            <div class="relative">
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Business Category</small
                >
              </div>
              <el-select
                v-model="businessSuite"
                placeholder="Business Category"
                class="w-full mt-2"
                value-key="_id"
                filterable
              >
                <el-option
                  v-for="item in options"
                  :key="item._id._id"
                  :label="item.name"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
            <!-- <div class="relative mt-4">
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium">Sub-Category</small>
              </div>
              <el-select
                v-model="value"
                placeholder="Sub-Category"
                class="w-full mt-2"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
          </div>
          <div
            class="absolute bottom-0 margin-niche right-0 left-0 w-full flex justify-between"
          >
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/Default.svg"
                class="mar-left"
                @click="handleClick('profile-v')"
              />
            </div>
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class="mar-right"
                @click="handleClick('fonts')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="w-8/12 bg-primary h-full relative">
        <div
          class="flex justify-center z-50 items-center height-100 text-center"
        >
          <div class="mx-auto">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/king.png"
              alt="image"
              class="img300"
            />
            <h1 class="text-3xl mt-6 text-white text-left font-semibold">
              Which Industry are you <br />
              planning to conqure
            </h1>
          </div>
        </div>
        <div class="absolute top-0 left-0 w-full">
          <div class="grid grid-cols-1 gap-4">
            <marquee
              class="bg-transparent text-white font-semibold mb-0"
              scrollamount="20"
            >
              <div class="grid grid-cols-1 gap-5">
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name2.png"
                  class="w-full height-marf"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name2.png"
                  class="w-full height-marf"
                />
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name2.png"
                  class="w-full height-marf"
                />
              </div>
            </marquee>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      bussi: "",
      businessSuite: "",
      options: [],
      completed: false,
      // businessSuitesArray: [],
    };
  },
  computed: {
    ...mapState("brandProfile", {
      brandProfile: "brandProfile",
    }),
    ...mapState("brandProfile", {
      businessSuites: "businessSuites",
    }),
    ...mapState("user", { selectedProject: "selectedProject" }),
  },
  methods: {
    IScompleted() {
      if (this.completed === true) {
        this.$router.push({ name: "dashboard" });
      }
    },
    async init() {
      let data = await this.$store.dispatch("brandProfile/getBusinessSuites");
      // console.log(this.businessSuites);
      this.businessSuites.map((suits) => {
        if (suits.hasOwnProperty("name") && suits.hasOwnProperty("_id")) {
          // return { _id: suits._id, name: suits.name };
          this.options.push({ _id: suits, name: suits.name });
        }
      });
      // console.log(this.brandProfile);
      if (this.brandProfile.hasOwnProperty("businessCategory")) {
        this.businessSuite = this.brandProfile.businessCategory.name
          ? this.brandProfile.businessCategory.name
          : this.selectedProject.suites[0].title;
      }
    },

    async handleClick(name) {
      // console.log(this.businessSuite);
      // console.log(this.selectedProject);
      let payloadBusinessSuite = {
        businessCategory: this.businessSuite,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      // console.log(this.brandProfile);
      // if (
      //   this.brandProfile.hasOwnProperty("businessCategory") &&
      //   this.businessSuite !== this.brandProfile.businessCategory._id
      // ) {
      let data = await this.$store.dispatch(
        "brandProfile/uploadBrandProfile",
        payloadBusinessSuite
      );
      // console.log(data);
      // }
      let payloadBrand = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      await this.$store.dispatch("brandProfile/getBrandProfile", payloadBrand);
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
    this.completed = this.brandProfile.isCompleted;
    // this.IScompleted();
    console.log(this.selectedProject.suites[0].title, "Yshsh");
  },
};
</script>
